import { render } from "./IconTooltip.vue?vue&type=template&id=3be6b852&scoped=true"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"

import "./IconTooltip.vue?vue&type=style&index=0&id=3be6b852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be6b852"]])

export default __exports__